import script from "./ProgTitleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgTitleEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProgTitleEdit.vue?vue&type=style&index=0&id=0d8a69cc&lang=scss"

const __exports__ = script;

export default __exports__